import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<input aria-label={{t \"general.pickADate\"}} class=\"date-picker\" {{date-picker @value minDate=@minDate maxDate=@maxDate locale=this.intl.primaryLocale onChangeHandler=@onChange}} ...attributes />", {
  moduleName: "ilios-common/components/date-picker.hbs"
});